'use client';

import { useEffect, useState } from 'react';
import { useLocalStorage } from '../hooks/use-local-storage';

export function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);
  const [cookieConsent, setCookieConsent] = useLocalStorage<string | null>('cookie-consent', null);

  useEffect(() => {
    // Show banner if consent hasn't been given
    if (cookieConsent === null) {
      setShowBanner(true);
    }
  }, [cookieConsent]);

  const handleAccept = () => {
    setCookieConsent('accepted');
    setShowBanner(false);
  };

  const handleDecline = () => {
    setCookieConsent('declined');
    setShowBanner(false);
    // Clear non-essential cookies
    document.cookie.split(';').forEach((cookie) => {
      const namePart = cookie.split('=')[0];
      if (namePart && !isEssentialCookie(namePart.trim())) {
        document.cookie = `${namePart}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
      }
    });
  };

  if (!showBanner) return null;

  return (
    <div className="fixed right-0 bottom-0 left-0 z-50 border-t border-gray-200 bg-white p-4 shadow-lg">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 sm:flex-row">
        <div className="text-sm text-gray-600">
          <p>
            We use cookies to enhance your shopping experience. Some cookies are essential for core
            functionality, while others help us improve our services.
          </p>
          <p className="mt-1">
            <button
              className="text-pion-blue hover:underline"
              onClick={() => window.open('/privacy-policy', '_blank')}
            >
              Learn more about our cookie policy
            </button>
          </p>
        </div>
        <div className="flex gap-4">
          <button
            onClick={handleDecline}
            className="px-4 py-2 text-sm text-gray-600 hover:text-gray-800"
          >
            Decline Non-Essential
          </button>
          <button
            onClick={handleAccept}
            className="bg-pion-blue rounded-md px-4 py-2 text-sm text-white hover:bg-blue-600"
          >
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
}

// Helper to identify essential cookies
function isEssentialCookie(name: string): boolean {
  const essentialCookies = [
    'device_id', // Required for basic Shopify functionality
    '_identity_session' // Required for authentication
  ];
  return essentialCookies.includes(name);
}
